import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
// import dsBankApi from "service/TichHopBank/dsBankApi";
// import userApi from "../../../service/userApi";
import { pushNotification } from "utils/notifications";
import ThietLapHienThiApi from "../../service/QuanTriHeThong/ThietLapHienThiApi";

export const ModelThietLapHienThi = (props) => {
  const [data, setData] = useState({});
  const [bDisable, setDisableButton] = useState(false);
  const [SuDungCongTacVienNhanVien, setSuDungCongTacVienNhanVien] =
    useState(false);
  const [SuDungMaNhanVien, setSuDungMaNhanVien] = useState(false);
  useEffect(() => {
    setData(props.data);
    setSuDungCongTacVienNhanVien(props.SuDungCongTacVienNhanVien);
    setSuDungMaNhanVien(props.SuDungMaNhanVien);
  }, []);

  const toggleCheckThietLap = (e, field) => {
    const checked = !e.target?.checked ?? true;
    setData((prev) => ({
      ...prev,
      [field]: checked,
    }));
  };
  const addOrEdit = () => {
    setDisableButton(true);
    ThietLapHienThiApi.saveThietLapDanhSachTinChap(data).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        props.onHide();
        props.getThietLapHienThi();
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response, "error", "TOP_CENTER", 2000);
      }
    });
  };
  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fade modal-new modal fade text-left modal show"
      backdrop="static"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="fa fa-cog"></i>
          </span>
        <span className="btn-link color-xanh">Thiết lập hiển thị</span>
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnSTT}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnSTT")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">STT</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnTenKH}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnTenKH")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Tên khách hàng</label>
              </div>
            </div>
          </div>
        </div>
        {(SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
          <div className="row">
            {SuDungMaNhanVien && (
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-1">
                    <input
                      style={{ marginRight: "10px" }}
                      type="checkbox"
                      checked={!data.IsAnNhanVien}
                      onChange={(e) => toggleCheckThietLap(e, "IsAnNhanVien")}
                    />
                  </div>
                  <div className="col-md-8">
                    <label className="label-control">Nhân viên</label>
                  </div>
                </div>
              </div>
            )}
            {SuDungCongTacVienNhanVien && (
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-1">
                    <input
                      style={{ marginRight: "10px" }}
                      type="checkbox"
                      checked={!data.IsAnNhanVien}
                      onChange={(e) => toggleCheckThietLap(e, "IsAnNhanVien")}
                    />
                  </div>
                  <div className="col-md-8">
                    <label className="label-control">Mã nhân viên</label>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnMaHD}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnMaHD")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Mã hợp đồng</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnTinChap}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnTinChap")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Tín chấp</label>
              </div>
            </div>
          </div>
        </div>
        {/* -------------- */}
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnSoTienVay}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnSoTienVay")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Số tiền vay</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnSoTienDaTra}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnSoTienDaTra")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Số tiền đã trả</label>
              </div>
            </div>
          </div>
        </div>
        {/* -------------- */}
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnTienVayConLai}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnTienVayConLai")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Tiền vay còn lại</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnChiPhiVayToiHomNay}
                  onChange={(e) =>
                    toggleCheckThietLap(e, "IsAnChiPhiVayToiHomNay")
                  }
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Lãi tới hôm nay</label>
              </div>
            </div>
          </div>
        </div>
        {/* -------------- */}
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnTrangThai}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnTrangThai")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Trạng thái</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnChucNang}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnChucNang")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Chức năng</label>
              </div>
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <p></p>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          className="btn btn-new-main btn-checknew"
          onClick={addOrEdit}
          disabled={bDisable}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Cập nhật
        </button>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
